import { useEffect, useState } from 'react';
import ValidatedInput, { ValidatedState } from '../../components/custom-input/ValidatedInput';
import { Validators } from '../../types/enums';
import { StorageSite, StorageTank } from '../../types/interfaces';
import { showToast } from '../../services/toast.service';
import { toastMessages } from '../../constants/errorMessages';
import { updateStorageTank } from '../../api/storageItemsApi';
import './locationManagement.scss';

type EditTankModalProps = {
  close: () => void;
  site: StorageSite;
  tank: StorageTank;
};

const EditTankModal = ({ close, site, tank }: EditTankModalProps): JSX.Element => {
  const [nameInput, setNameInput] = useState<ValidatedState>({ valid: true, value: tank.name });
  const [activeInput, setActiveInput] = useState<boolean>(tank.active);
  const [travelingInput, setTravelingInput] = useState<boolean>(tank.isTravelingTank);
  const [validate, setValidate] = useState<boolean>(false);
  const [submit, setSubmit] = useState<boolean>(false);

  useEffect(() => {
    const action = async () => {
      try {
        await updateStorageTank(tank.storageTankId, { name: nameInput.value, active: activeInput, isTravelingTank: travelingInput });
        showToast.success(toastMessages.TANK_UPDATE_SUCCESS);
      } catch {
        showToast.success(toastMessages.TANK_UPDATE_FAIL);
      } finally {
        setSubmit(false);
        close();
      }
    };
    if (submit) {
      action();
    }
  }, [submit]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setValidate(true);
    if (nameInput.valid) {
      setSubmit(true);
    }
  };

  return (
    <div className="management-columns-modal">
      <form onSubmit={handleSubmit}>
        <h2>Edit Tank</h2>
        <p>Please complete the form to update your tank.</p>
        <div className="form-row">
          <label>Site Name:</label>
          <div className="input-container">
            <label>{site.name}</label>
          </div>
        </div>
        <ValidatedInput
          useId="name-input-field"
          type="text"
          label={'Tank Name'}
          validate={validate}
          validatedStateForAutoFill={nameInput}
          setValidatedState={setNameInput}
          validators={[Validators.REQUIRED]}
        />
        <div className="form-row">
          <label htmlFor="active-checkbox">Active</label>
          <div className="input-container">
            <input
              id="active-checkbox"
              type="checkbox"
              defaultChecked={tank.active}
              onChange={e => setActiveInput(e.target.checked)}
            />
          </div>
          <div className="form-row">
            <label htmlFor="traveling-checkbox">Traveling Tank</label>
            <div className="input-container">
              <input
                id="traveling-checkbox"
                type="checkbox"
                defaultChecked={tank.isTravelingTank}
                onChange={e => setTravelingInput(e.target.checked)}
              />
            </div>
          </div>
        </div>
        <div className="flex-right submit-button">
          <button type="button" className="small green inverted button" onClick={close}>
            Cancel
          </button>
          &emsp;
          <button type="submit" className={nameInput.valid ? 'small green button' : 'small green button disabled'}>
            Update
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditTankModal;
